import React, { useEffect, useState } from "react"
import styled from "styled-components"
import dayjs from "dayjs"
import { Location, useFields } from "../App"
import "dayjs/locale/nl"

dayjs.locale("nl")

// @ts-ignore
const LicensePlateInput = styled.input`
    box-shadow: none !important;
    &::placeholder {
        color: rgba(0, 0, 0, 0.5);
    }
`

interface Props {
    location: Location
}

export default function StepFour({ location }: Props) {
    const fields = useFields()
    const [isLoading, setIsLoading] = useState(false)
    const [errors, setErrors] = useState<string[]>([])

    useEffect(() => {
        handleSubmit().then(() => {
            console.log("Submit")
        })
    }, [])

    async function handleSubmit() {
        if (isLoading) {
            return;
        }
        setIsLoading(true)

        const res = await fetch("/wp-json/sites/v1/werkplaatsafspraak", {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                firstName: fields.form.firstName,
                lastName: fields.form.lastName,
                email: fields.form.email,
                phone: fields.form.phone,
                message: fields.form.message,
                licensePlate: fields.licensePlate,
                options: fields.options.join(", "),
                location: fields.location,
                date: dayjs(fields.date).format("dddd D MMMM YYYY"),
                time: fields.time,
                timeComment: fields.timeComment,
            }),
        })

        if (res.ok) {
            fields.setComplete(true)
            await res.json()
        } else {
            try {
                const errors = await res.json()
                setErrors(errors)
            } catch (error) {
                setErrors(["Er is iets mis gegaan..."])
            }
        }

        setIsLoading(false)
    }

    if (isLoading) {
        return (
            <div>
                <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                </svg>
            </div>
        )
    }

    if (errors.length > 0) {
        return (
            <div className="mt-10">
                <div className="mb-4">
                    De volgende fouten zijn ontstaan bij het opsturen van de
                    afspraak:
                </div>
                {errors.map((error) => (
                    <div className="text-[tomato] mb-1" key={error}>
                        {error}
                    </div>
                ))}
            </div>
        )
    }

    return (
        <div className="sm:mt-10">
            <h2 className="sm:text-2xl text-lg">Overzicht aanvraag</h2>
            <p>
                Bedankt voor je aanvraag voor een werkplaatsafspraak. Wij nemen
                contact met je op om de afspraak te bevestigen. Indien het niet
                mogelijk is om de afspraak op het door jou gewenste moment door
                te laten gaan, zullen wij een ander moment met je plannen. De
                afspraak is pas definitief als je van ons een bevestiging hebt
                ontvangen.
            </p>

            <div className="flex sm:mb-10 mb-6">
                <div className="bg-[#1762AB] flex flex-col items-center justify-between text-light w-[40px] h-[52px] py-1">
                    <img
                        className="w-[29px] h-[29px] mb-[1px]"
                        src={`${window.local_werkplaatsafspraak_object.asset}/license-stars.svg`}
                        alt=""
                    />
                    <span className="text-xs">NL</span>
                </div>

                <LicensePlateInput
                    onInput={(event) => event.preventDefault()}
                    type="text"
                    className="bg-[#F9BF2A] w-[250px] flex flex-col justify-center items-center text-center text-xl tracking-widest border-none text-dark"
                    value={fields.licensePlate}
                    disabled
                />
            </div>

            <div className="mb-5">
                <strong className="block">Werkzaamheden:</strong>
                <ul>
                    {fields.options.map((option) => (
                        <li
                            key={option}
                            className="children-mb-0"
                            dangerouslySetInnerHTML={{ __html: option }}
                        />
                    ))}
                </ul>
            </div>

            <div className="grid sm:grid-cols-2">
                <span>{location.title}</span>
                <span>
                    {location.manager} - {location.manager_function}
                </span>
                <span>{location.email}</span>
                <span>{location.phone}</span>

                <span className="sm:col-span-2">
                    {dayjs(fields.date).format("dddd D MMMM YYYY")} -{" "}
                    {fields.time}
                </span>
            </div>

            <a className="button primary sm:mt-10 mt-8" href="/">
                Naar homepage
            </a>
        </div>
    )
}
